import { Link } from "react-router-dom";
import ContactPanel from "@/components/ContactPanel";

export default function Footer({ onEnquiry }) {
  return (
    <footer id="contact" data-testid="ugi-footer-section" className="border-t border-[#C5A059]/20 bg-[#15100E] text-[#FDFBF7]">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-14 sm:px-8 lg:grid-cols-[1.05fr_1.1fr_0.65fr]">
        <div>
          <img data-testid="footer-ugi-logo" src="/assets/ugi-official-logo-web.png" alt="Unity Gateway International LLP official logo" className="w-56 max-w-full object-contain" />
          <p className="mt-6 max-w-sm text-sm leading-7 text-[#A89F91]">
            Unity Gateway International LLP supports buyer-led trade conversations across India, GCC, African and wider global corridors.
          </p>
          <button data-testid="footer-contact-button" onClick={onEnquiry} className="mt-7 border border-[#C5A059]/50 px-5 py-3 text-[11px] font-bold tracking-[0.16em] text-[#C5A059] transition-colors hover:bg-[#C5A059] hover:text-[#15100E] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C5A059]">
            SUBMIT AN ENQUIRY
          </button>
        </div>
        <ContactPanel />
        <div>
          <h2 className="text-sm font-bold uppercase tracking-[0.26em] text-[#C5A059]">Navigate</h2>
          <nav aria-label="Footer navigation" className="mt-5 grid gap-3 text-sm text-[#A89F91]">
            <Link data-testid="footer-link-about" to="/" className="transition-colors hover:text-[#FDFBF7]">About UGI</Link>
            <Link data-testid="footer-link-focus-areas" to="/focus-areas" className="transition-colors hover:text-[#FDFBF7]">Current Focus Areas</Link>
            <Link data-testid="footer-link-corridor" to="/source" className="transition-colors hover:text-[#FDFBF7]">How UGI Works</Link>
            <Link data-testid="footer-link-insights" to="/insights" className="transition-colors hover:text-[#FDFBF7]">UGI Insights</Link>
            <a data-testid="footer-link-contact" href="#contact" className="transition-colors hover:text-[#FDFBF7]">Contact</a>
          </nav>
        </div>
      </div>
      <div className="border-t border-[#FDFBF7]/10 px-5 py-6 text-center text-xs tracking-[0.12em] text-[#A89F91]">
        © {new Date().getFullYear()} Unity Gateway International LLP. All rights reserved.
      </div>
    </footer>
  );
}
